import PhoneNumberValidationInput from './PhoneNumberValidationInput';
export default PhoneNumberValidationInput;
